/** Generate a random 8-digit number for MercadoPago's required identityDocument field */
export function generateRandomDocumentId(): number {
  return Math.floor(Math.random() * (100000000 - 10000000) + 10000000);
}
